'use strict';

module.exports = [
  '$translate',
  DomainErrorMessageDirective];

function DomainErrorMessageDirective($translate) {
  return {
    restrict: 'A',
    scope: {
      domainErrors: '=' // must be an array of FieldError objects
    },
    priority: $translate.directivePriority() + 1,
    link: function ($scope, $element, $attrs) {
      var currentErrorMessages;
      var unwatch = $scope.$watch($scope.domainErrors.$size.bind($scope.domainErrors),
        function () {
          if ($scope.domainErrors && $scope.domainErrors.length) {
            currentErrorMessages = new Array($scope.domainErrors.length);
            for (var i = 0; i < $scope.domainErrors.length; i++) {
              currentErrorMessages[i] = getErrorMessage($scope.domainErrors[i]);
            }
          } else {
            currentErrorMessages = [];
          }

          // currently only showing 1 message
          // TODO: display all or add support for more behavior
          displayMessage(currentErrorMessages.length ? currentErrorMessages[0] : '');
        });

      function getErrorMessage(fieldError) {
        var result;
        try {
          if (!fieldError) {
            return '';
          } else {
            result = $translate.instant(fieldError.code, fieldError.arguments);
            console.debug('translating result for code ' + fieldError.code + ': ' + result);
            if (result !== fieldError.code) {
              return result;
            } else {
              return $translate.instant(fieldError.defaultCode, fieldError.arguments)
            }
          }
        } catch (error) {
          console.warn('An error occurred attempting to translate an error message');
          console.error(error);
        }
      }

      function displayMessage(message) {
        $element.html(message);
      }

      $scope.$on('$destroy', unwatch)
    }
  };
}


// WEBPACK FOOTER //
// ./src/js/domain-directives/DomainErrorMessageDirective.js